import { useEffect, useState, useCallback } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { logger } from "@/lib/logger";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const session_id = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { clear } = useCart();

  useEffect(() => {
    if (!session_id) { setStatus("error"); return; }
    let attempts = 0;
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${session_id}`);
        if (cancelled) return;
        if (data.payment_status === "paid") { setStatus("paid"); clear(); return; }
        if (attempts > 10) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch (err) {
        if (!cancelled) { logger.error("Payment poll failed:", err); setStatus("error"); }
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [session_id, clear]);

  return (
    <section className="max-w-[720px] mx-auto px-6 py-24 text-center">
      {status === "checking" && <><p className="font-mono text-xs tracking-[0.3em] uppercase text-[#C5A059]">Confirming</p><h1 className="font-serif text-5xl mt-4">Confirming your payment…</h1></>}
      {status === "paid" && <><p className="font-mono text-xs tracking-[0.3em] uppercase text-[#C5A059]">Success</p><h1 className="font-serif text-5xl mt-4">Thank you.</h1>
        <p className="mt-6 text-[#555]">Your order is confirmed. Upload artwork from your dashboard to begin production.</p>
        <Link to="/dashboard" data-testid="success-dashboard" className="mt-10 inline-block bg-[#0a0a0a] text-white hover:bg-[#C5A059] hover:text-[#0a0a0a] transition-colors px-10 py-4 text-xs tracking-[0.25em] uppercase font-bold">Go to Dashboard</Link></>}
      {status === "timeout" && <><h1 className="font-serif text-4xl">Still processing</h1><p className="mt-4 text-[#555]">Check your dashboard shortly.</p></>}
      {status === "error" && <><h1 className="font-serif text-4xl">Something went wrong</h1><p className="mt-4 text-[#555]">Please contact support if you were charged.</p></>}
    </section>
  );
}
